import { render, staticRenderFns } from "./LoanDetailsView.vue?vue&type=template&id=19ea667c&"
import script from "./LoanDetailsView.vue?vue&type=script&lang=js&"
export * from "./LoanDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./LoanDetailsView.vue?vue&type=style&index=0&id=19ea667c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports